import { render, staticRenderFns } from "./OtherReasons.vue?vue&type=template&id=0cdbca11&"
import script from "./OtherReasons.vue?vue&type=script&lang=js&"
export * from "./OtherReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports